<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">Assign Organizers</h2>
      <base-button
        type="primary"
        round
        icon
        class="top-button"
        @click="$router.push('add?id=-1')"
      >
        <i class="fa fa-plus"></i>
      </base-button>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title"></h4>
          <div>
            <el-table :data="queriedData">
              <el-table-column :min-width="200" align="left" label="Name">
                <div slot-scope="props">
                  <div style="display: flex">
                    <div>
                      <div>
                        {{ props.row.username }} <br />
                        {{ props.row.displayname }} <br />
                      </div>
                    </div>
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="200" align="left" label="Status">
                <div style="display: flex" slot-scope="props">
                  <base-button
                    v-if="props.row._id !== event.organizer"
                    native-type="submit"
                    type="primary"
                    value="Compares"
                    @click="Update(props.row._id)"
                    class="btn-fill"
                    >Assign</base-button
                  >
                </div>

                <div
                  style="display: flex"
                  slot-scope="props"
                  v-if="props.row._id == event.organizer"
                >
                  <p style="display: flex">Currently Assigned</p>
                </div>
              </el-table-column>


              <el-table-column :min-width="200" align="left" label="Action">
                <div style="display: flex" slot-scope="props">
                  <base-button
                   v-if="props.row._id !== event.organizer"
                    native-type="submit"
                    type="primary"
                    value="Compares"
                    @click="Update(props.row._id)"
                    class="btn-fill"
                    >Assign</base-button
                  >
                </div>

             
              </el-table-column>
            </el-table>
          </div>
          <div></div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import { Modal, BaseAlert } from "src/components";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    BaseAlert,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      debugger;
      console.log("hello");
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        console.log(this.searchedData);
        console.log("search data ");
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      isSuccess: "",
      organizer: [],
      loading: true,
      noDataMessage: false,
      modals_classic: false,
      actions: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["username"],
      tableColumns: [
        {
          prop: "username",
          label: "username",
          minWidth: 200,
        },
      ],
      tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentOrder: {},

      event: {},
    };
  },
  async mounted() {
    debugger;

    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["username", "displayname"],
      threshold: 0.3,
    });

    this.loading = true;
    debugger;
    let admin = await this.$apiService.postCall("admin/getAllAdmin");

    console.log("Admin Data");
    console.log(admin);
    this.tableDatas = admin.apidata.Data || [];

    this.tableData = this.tableDatas.reverse();
    this.organizer = this.tableData;
    console.log(this.tableData);

    var id = this.$route.query.event_id;

    let eve = await this.$apiService.getCall("event/eventbyId/" + id);
    debugger;
    this.event = eve.apidata.Data.event;
    this.loading = false;
    console.log(eve);
    debugger;
  },

  methods: {
    async Update(id) {
      debugger;
      var event_id = this.$route.query.event_id;

      var postdata = {
        event_id: event_id,
        organizer_id: id,
      };

      const event = await this.$apiService.postCall(
        "event/assign-organizer/",
        postdata
      );
      console.log(event);
      debugger;
      // this.isSuccess = event.apidata.Message;

      // this.tableData.forEach((element) => {
      //   if (element._id === id) {
      //     element.values = true;
      //   } else {
      //     element.values = false;
      //   }
      // });
      console.log(this.tableData);

      this.$apiService.notify("Organizer Has been Assigned.");
      window.location.reload();
    },
  },

  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      console.log("search ");
      console.log(value);
      console.log(this.searchQuery);
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.pagination-select,
.search-input {
  width: 200px;
}
.swal2-icon-content {
  font-size: inherit !important;
}
</style>
